// System Widgets
import User from './System/User'

// Bl Widgets
import CareerContacts from './Bl/CareerContacts'
import ProcessFiles from './Bl/ProcessFiles'
import Authorizations from './Bl/Authorizations'
import Contacts from './Bl/Contacts'

export default {
  System: {
    User
  },

  Bl: {
    Authorizations,
    CareerContacts,
    ProcessFiles,
    Contacts
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/index.js